"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePasswordRecover = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
function usePasswordRecover() {
    const { data: success, isLoading, error, post } = (0, core_ui_1.useApiPost)('users/password/recover');
    const doPasswordRecover = (0, react_1.useCallback)((email) => {
        post({ email });
    }, [post]);
    return { success, isLoading, error, doPasswordRecover };
}
exports.usePasswordRecover = usePasswordRecover;
//# sourceMappingURL=usePasswordRecover.js.map